import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ROUTE_CONSTANTS } from '@utilities/RouteConstants';
import { ScheduleSection } from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseRequestPage/ScheduleSection/ScheduleSection';
import { BlockDetailsSection } from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseRequestPage/BlockDetailsSection/BlockDetailsSection';
import { useBlockReleaseRequestContext } from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseRequestContext/BlockReleaseRequestContext';
import { BlockReleaseCaughtUpMessage } from '@components/BlockRelease/BlockReleaseCaughtUpMessage/BlockReleaseCaughtUpMessage';
import { BlockReleaseNudgeCaughtUpMessage } from '@components/BlockRelease/BlockReleaseNudgeCaughtUpMessage/BlockReleaseNudgeCaughtUpMessage';
import { findNextRelease } from '@components/BlockRelease/utils/findNextRelease/findNextRelease';
import {
	BlockReleaseInUseDialog
} from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseInUseDialog/BlockReleaseInUseDialog';
import { BLOCK_RELEASE_MAX_HEIGHT } from '@theme/themeConstants';
import { useSelector } from 'react-redux';
import { shouldShowGlobalLoaderSelector } from '@store/selectors/ApiStatusSelector';

const useStyles = makeStyles((theme) =>
	createStyles({
		infoSection: {
			gridArea: 'blockInfoSection',
			display: 'grid',
			gridTemplateColumns: 'minmax(300px, 1fr) 248px',
			gridTemplateAreas: `"blockDetails schedule"`,
			gap: theme.spacing(4),
			maxHeight: BLOCK_RELEASE_MAX_HEIGHT,
		},
		messageSection: {
			marginRight: theme.spacing(1),
		},
	}),
);

export const BlockInfoSection = () => {
	const classes = useStyles();
	const { releases, selectedReleaseInfo } = useBlockReleaseRequestContext();
	const location = useLocation();
	const isOnRecommendedReleasesPage = location.pathname.includes(ROUTE_CONSTANTS.BLOCK_RELEASE_RECOMMENDATION_LIST);

	const nextRelease = React.useMemo(
		() =>
			isOnRecommendedReleasesPage ? findNextRelease(releases) : null,
		[releases, isOnRecommendedReleasesPage]);

	const isLoading = useSelector(shouldShowGlobalLoaderSelector);
	if (isLoading) {
		return null;
	}

	if (!selectedReleaseInfo?.blockInfo || !selectedReleaseInfo?.facility || !selectedReleaseInfo.selectedRelease) {
		if (!nextRelease) {
			return (
				<Box className={classes.messageSection}>
					<BlockReleaseCaughtUpMessage
						message="You have no recommended block time to release."
					/>
				</Box>
			);
		} else {
			return (
				<Box className={classes.messageSection}>
					<BlockReleaseNudgeCaughtUpMessage
						nextRelease={nextRelease}
					/>
				</Box>
			);
		}
	}

	return (
		<Box className={classes.infoSection}>
			<BlockReleaseInUseDialog />
			<BlockDetailsSection selectedReleaseInfo={selectedReleaseInfo}/>
			<ScheduleSection selectedReleaseInfo={selectedReleaseInfo}/>
		</Box>
	);
};
